import React from 'react';
import { CalendarDays, Clock, Video } from 'lucide-react';
import PortalLayout from './PortalLayout';
import EmbedSchedulePage from '../EmbedSchedulePage';

const muted = { color: 'var(--p-muted)' };

/**
 * In-portal booking. Renders the chrome-less DCA scheduler inside the portal
 * shell so the member never leaves the portal to book a session.
 */
export default function ClientBook() {
  return (
    <PortalLayout active="book">
      <div className="mb-8" data-testid="portal-book">
        <span className="text-xs tracking-[0.2em] uppercase text-[#F97316] font-semibold p-eyebrow">Scheduling</span>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-light mt-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Book a session with David
        </h1>
        <p className="mt-2 max-w-2xl" style={muted}>Grab your free 20-minute Jumpstart or book a 1-on-1. Pick a service and time below.</p>
      </div>

      <div className="p-card rounded-2xl p-5 mb-6 flex items-start gap-4" data-testid="portal-weekly-training">
        <div className="w-11 h-11 rounded-xl bg-[#F97316]/12 text-[#F97316] flex items-center justify-center flex-shrink-0">
          <Video size={20} />
        </div>
        <div>
          <h3 className="font-semibold" style={{ fontFamily: 'Outfit, sans-serif' }}>Free weekly Business Jumpstart Q&amp;A</h3>
          <p className="text-sm mt-0.5 inline-flex items-center gap-2 flex-wrap" style={muted}>
            <span className="inline-flex items-center gap-1"><CalendarDays size={13} /> Every Monday</span>
            <span className="inline-flex items-center gap-1"><Clock size={13} /> 12:00 PM &amp; 8:00 PM ET</span>
            <span style={{ color: 'var(--p-faint)' }}>· Virtual / Zoom · Free</span>
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl overflow-hidden border" style={{ borderColor: 'var(--p-border)' }} data-testid="portal-scheduler">
        <EmbedSchedulePage brandSlug="dca" inPortal />
      </div>
    </PortalLayout>
  );
}
